<template>
    <div class="tabs">
        <div class="tab-header-wrapper hidden-xs">
            <ul class="tab-header">
                <li v-for="tab in tabs" class="tab-trigger">
                    <a
                        @click="selectTab(tab.name)"
                        :class="{'is-active':tab.isActive}"
                        style="cursor:pointer;"
                    >
                        {{ tab.title }}
                    </a>
                </li>
                <slot name="tab-action"></slot>
            </ul>
        </div>
        <div class="tab-details">
            <slot></slot>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      selectedTab: {
        default: false
      }
    },
    data: () => ({
      tabs: [],
    }),
    methods: {
      selectTab(selectedTab) {
        this.tabs.forEach(tab => {
          tab.isActive = (tab.name === selectedTab)
        })
      }
    },
    mounted() {
      this.tabs = this.$children;
      this.selectTab(this.selectedTab);
    }
  }
</script>